/* RESPONSIBLE TEAM: team-fin-qa */
import ApplicationAdapter from '../application';

export default class CxScoreReasonAdapter extends ApplicationAdapter {
  namespace = '';

  pathForType() {
    return 'teammate_app/qa/monitors/cx_score_reasons';
  }
}
